import { Link } from 'react-router-dom';

import style from './NotebookPageHeaderTeacherView.scss';

const NotebookPageHeaderTeacherView = ({
  lessonTitle,
  classCode,
  previousLessonLink,
  nextLessonLink,
  currentStudentName,
  previousStudentLink,
  nextStudentLink,
}: NotebookPageHeaderTeacherViewProps): JSX.Element => {
  const previousLessonLinkText = '<< Previous lesson';
  const nextLessonLinkText = 'Next lesson >>';
  const previousStudentLinkText = '<< Previous student';
  const nextStudentLinkText = 'Next student >>';

  return (
    <>
      <div className={style.headerContainer}>
        <div className={style.wrapper}>
          <h1 className={style.lessonTitle}>{lessonTitle}</h1>
          <div className={style.lessonLinks}>
            {previousLessonLink ? (
              <Link
                to={previousLessonLink}
                className={style.previousLessonLink}
              >
                {previousLessonLinkText}
              </Link>
            ) : (
              <span className={style.disabledLink}>
                {previousLessonLinkText}
              </span>
            )}
            <span className={style.spacer}>|</span>
            {nextLessonLink ? (
              <Link to={nextLessonLink} className={style.nextLessonLink}>
                {nextLessonLinkText}
              </Link>
            ) : (
              <span className={style.disabledLink}>{nextLessonLinkText}</span>
            )}
          </div>
        </div>

        <div className={style.wrapper}>
          <div>
            <span className={style.classCode}>{classCode}</span>
          </div>
          <div>
            {previousStudentLink ? (
              <Link
                to={previousStudentLink}
                className={style.previousStudentLink}
              >
                {previousStudentLinkText}
              </Link>
            ) : (
              <span className={style.disabledLink}>
                {previousStudentLinkText}
              </span>
            )}

            <span className={style.spacer}>|</span>
            <span>{currentStudentName}</span>
            <span className={style.spacer}>|</span>

            {nextStudentLink ? (
              <Link to={nextStudentLink} className={style.nextStudentLink}>
                {nextStudentLinkText}
              </Link>
            ) : (
              <span className={style.disabledLink}>{nextStudentLinkText}</span>
            )}
          </div>
        </div>
      </div>
      <div className={style.divider} />
    </>
  );
};

export default NotebookPageHeaderTeacherView;

interface NotebookPageHeaderTeacherViewProps {
  lessonTitle: string;
  classCode: string;
  previousLessonLink: string;
  nextLessonLink: string;
  currentStudentName: string;
  previousStudentLink: string;
  nextStudentLink: string;
}
